import { Component, Input, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';

@Component({
  selector: 'app-text-preview-tooltip',
  templateUrl: './text-preview-tooltip.component.html',
  styleUrls: ['./text-preview-tooltip.component.css']
})
export class TextPreviewTooltipComponent implements AfterViewChecked {
  @Input() text: string | undefined | null = '';
  @Input() maxWidth: number = 200;
  @ViewChild('textElement') textElementRef!: ElementRef;
  isTooltip: boolean = false;
  textTooltip: string = '';
  isHovered: boolean = false;

  ngAfterViewChecked() {
    this.updateDisplayText();
  }

  onMouseOver() {
    this.isHovered = true;
  }

  onMouseLeave() {
    this.isHovered = false;
  }


  updateDisplayText() {
    const textElement = this.textElementRef.nativeElement;
    // Comprobamos si el texto excede el ancho del contenedor
    if (textElement.scrollWidth > textElement.clientWidth) {
      this.isTooltip = true;
      if(this.text ) {
        this.textTooltip = this.text
      } else{
        this.textTooltip = ""
      }
    } else {
      this.isTooltip = false;
      this.textTooltip = ""
    }
    if(this.text == undefined){
      this.text= ''
    }
  }
}
